(function ($) {
  const BTN_CLASS = 'btn'
  const LOADING_CLASS = 'is-loading'
  const ERROR_CLASS = 'has-error'

  /**
   * Set loading state for a button
   * @param isLoading - boolean
   * @returns {jQuery}
   */
  $.fn.hasLoadingState = function (isLoading = true) {
    this.each(function () {
      const el = $(this);

      // // That function works only for buttons (elements with the default button class) and anchors
      // if (!el.is('a') && !el.hasClass(BTN_CLASS)) {
      //   return
      // }

      el.toggleClass(LOADING_CLASS, isLoading)
      el.prop('disabled', isLoading)
    });

    return this;
  }

  /**
   * Add error class to element
   * @param hasError - boolean
   * @returns {jQuery}
   */
  $.fn.hasErrorState = function (hasError = true) {
    this.each(function () {
      if (hasError) {
        $(this).addClass(ERROR_CLASS)
      } else {
        $(this).removeClass(ERROR_CLASS)
      }
    });

    return this;
  }
})(jQuery);
